import { graphql } from 'relay-runtime';

export const UNIFIED_PROFILE_FRAGMENT = graphql`
  fragment UnifiedProfileFragment on UnifiedProfile @inline {
    id
    bio
    company
    aaid
    linkedinUrl
    accountInternalId
    location
    products
    role
    internalId
    username
    websiteUrl
    xUrl
    youtubeUrl
    isPrivate
    isPersonalView
    isLinkedView
    isProfileBanned
  }
`;
